<template>
  <custom-dialog width="60%" class="feed_back_tag_dialog" :append-to-body="true" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="margin: 0 24px">
      <el-tag :type="item.tagName === tagName?'':'info'" v-for="item in tagList" :key="item.tagName"  effect="plain"  @click="tagName=item.tagName">{{item.tagName}}</el-tag>
      <!-- <el-tag>{{ $t('pfb_tag1_biao_qian_yi') }}</el-tag>
      <el-tag type="success">{{ $t('pfb_tag1_biao_qian_er') }}</el-tag>
      <el-tag type="info">{{ $t('pfb_tag1_biao_qian_san') }}</el-tag> -->

      <el-button class="button-new-tag" @click="addTag">+</el-button>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <feed-back-addTag-dialog
      v-if="dialogVisible"
      @close="dialogVisible = false"
      :model="dialogModel"
      @success="getTagList(true)"
    ></feed-back-addTag-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import feedBackAddTagDialog from './feed_back_addTag_dialog';


export default {
  mixins: [dialogMixins],
  components: {
    feedBackAddTagDialog
  },
  data() {
    return {
      tagList: [],
      tagName: '',
      dialogVisible: false,
      dialogModel: {},
      isRefresh: false
    };
  },
  mounted() {
    this.getTagList();

  },
  methods: {
    // 获取数据
    getTagList(isRefresh = false) {
      this.isRefresh = isRefresh;
      this.$getJSON(apis.feedbackTagList, {
        tagType: this.model.tagType
        // 标签类型，2-改善措施，3-处理结果（客服），4-处理结果（品质）
      }).then((res) => {
        this.tagList = res.data;
      });
    },
    addTag() {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('components_feed_back_tag_dialog.xzcyct');
      this.dialogModel.tagType = this.model.tagType;
    },
    // 确认保存
    confirm: function () {

      if (this.tagName === '') {
        this.$message({
          message: this.$t('components_feed_back_tag_dialog.qxzcyct'),
          type: 'error',
        });
        return;
      }
      this.$emit('success', { tagName: this.tagName, tagType: this.model.tagType, isRefresh: this.isRefresh });
      this.visible = false;

    }
  }
};
</script>

<style lang="scss">
.feed_back_tag_dialog{
  .el-tag{
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .el-tag{
    height: 32px;
    line-height: 32px;
     cursor: pointer;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .el-tag--info{
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
  }

}
</style>
